<template>
  <div class="main">
    <div class="header">
      <div class="header_logo">
        <img src="@/assets/pictures/logo.png"/>
      </div>
    </div>

    <div class="register">
      <h2 class="register_title">{{$t("title.Register Title")}}</h2>
      <div class="register_form">
        <el-form ref="form" status-icon :model="form" :rules="rules" label-width="130px" label-position="left">
          <el-form-item :label="$t('Login and Register.Username')" prop="username" :rules="[
              { required: true, message: this.$t('Login and Register.UsernameTip'), trigger: 'blur' }
          ]">
            <el-input v-model="form.username" autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item :label="$t('Login and Register.Password')" prop="password">
            <el-input type="password" v-model="form.password" autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item :label="$t('Login and Register.Confirm Password')" prop="confirmedPassword">
            <el-input type="password" v-model="form.confirmedPassword" autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item :label="$t('Login and Register.City')" prop="cityName">
            <el-input v-model="form.cityName" autocomplete="off" @change="findCity"></el-input>
          </el-form-item>

          <el-form-item :label="$t('Login and Register.Organization')" prop="organization">
            <el-input v-model="form.organization" autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item :label="$t('Login and Register.Phone number')" prop="phone_number">
            <el-input type="number" v-model="form.phone_number" autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item :label="$t('Login and Register.Email')" prop="email">
            <el-input type="email" v-model="form.email" autocomplete="off"></el-input>
          </el-form-item>



          <el-form-item>

            <div class="button_left">
              <el-button @click="loginPage" style="background-color: lightsalmon">{{$t("button.Go back and Log in")}}</el-button>
            </div>

            <div class="button_right">
              <el-button @click="resetForm('form')">{{$t("button.Reset")}}</el-button>
              <el-button v-if="isOk" type="info" @click="doSubmitForm" plain>{{$t("button.Register")}}</el-button>
              <el-button v-if="!isOk" type="success" @click="submitForm('form')" plain>{{$t("button.Register")}}</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  name: "register",
  data() {
    var validatePass0 = (rule, value, callback) => {
      if (value === '') {
        if(this.$i18n.locale==='cn'){
          callback(new Error('所属城市不能为空'));
        }
        else{
          callback(new Error('City cannot be empty'));
        }
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        if(this.$i18n.locale==='cn'){
          callback(new Error('密码不能为空'));
        }
        else{
          callback(new Error('Password cannot be empty'));
        }
      } else {
        if (this.form.confirmedPassword !== '') {
          this.$refs.form.validateField('confirmedPassword');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        if(this.$i18n.locale==='cn'){
          callback(new Error('请再次输入密码'));
        }
        else{
          callback(new Error('Please enter the password again'));
        }
      } else if (value !== this.form.password) {
        if(this.$i18n.locale==='cn'){
          callback(new Error('两次输入密码不一致'));
        }
        else{
          callback(new Error('The passwords entered twice are inconsistent'));
        }
      } else {
        callback();
      }
    };

    return {
      form: {
        username: '',
        password:'',
        confirmedPassword: '',
        organization:'',
        phone_number:'',
        email:'',
        cityName:''
      },
      isOk:true,
      infoMessage:'',
      rules: {
        cityName:[
          { required: true, validator: validatePass0 , trigger: 'blur' }
        ],
        password: [
          {required:true, validator: validatePass, trigger: 'blur'},
          {min: 3, max: 20,message: this.$t('Login and Register.PasswordTip2'), trigger: "blur"}
        ],
        confirmedPassword: [
          {required:true, validator: validatePass2, trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    findCity(){
      var that=this
      request.get("/user/checkcity?cityName="+this.form.cityName).then(function (res){
        if(res.data===1) {
          that.isOk = false
        }
        if (res.data === 0) {
          that.isOk = true
          if (that.$i18n.locale === 'cn') {
            that.infoMessage = "该城市已经有账号 无法继续注册"
          } else {
            that.infoMessage = "This city already has an account and cannot continue to register."
          }
        }
        if (res.data === -1) {
          that.isOk = true
          if (that.$i18n.locale === 'cn') {
            that.infoMessage = "系统内未查询到该城市 请联系管理员"
          } else {
            that.infoMessage = "The city is not found in the system. Please contact the administrator."
          }
        }
      })
    },
    doSubmitForm(){
      alert(this.infoMessage)
    },
    submitForm(form) {
      var that=this
      that.$refs[form].validate((valid) => {that
        if (valid) {
          request.post('/user/register?confirmedPassword='+that.form.confirmedPassword+'&email='+that.form.email+'&organization='+that.form.organization+'&password='+that.form.password+'&phone_number='+that.form.phone_number+'&username='+that.form.username+'&cityName='+that.form.cityName).then(function (res){
            if(res.data.error_message ==='success'){
              console.log(res.data.error_message)
              if(that.$i18n.locale ==='cn'){
                alert("注册成功，请耐心等待管理员授权！")
                location.href='/login'
              }
              else{
                alert("Registration succeeded, please wait patiently for the administrator's authorization!")
              }
            }
            else{
              let mes=res.data.error_messgae
              alert(mes)
              // console.log(res.data)
            }
          }).catch(function (err){
            console.log(err)
          })
        } else {
          if(that.$i18n.locale==='cn'){
            alert('请根据提示更改信息！');
          }
          else{
            alert('Please change the information according to the prompts!');
          }
          return false;
        }
      });
    },
    resetForm(form) {
      this.$refs[form].resetFields();
    },
    loginPage(){
      this.$router.replace({name:'login'})
    }
  }
}
</script>

<style scoped>
.header{
  margin-top: 20px;
}
.register_title{
  text-align: center;
  color: #505458;
}
.register{
  border-radius: 15px;
  background-clip: padding-box;
  margin: 20px auto;
  width: 600px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
}
.button_left{
  float: left;
}
.button_right{
  float: right;
}
</style>